// main
import { useState } from "react";

import ContentFormatXC from "../content/webz/content-format-xc";

import WebbDividerMedium from "../content/webx/webb-divider-md";
import WebbDividerSmall from "../content/webx/webb-divider-sm";

import { GetUserForm } from "../services/srvc-utilities";

import NavsVault from "../content/vault/navs-vault";

import StoreListModule from "../content/collections/collections-list";
import UsersArtworksModule from "../content/vault/users-artworks";
import UsersVideosModule from "../content/vault/users-videos";
import TokensListModule from "../content/tokens/tokens-list";


export default function Vault (props) {
  
  const form = GetUserForm();

  const [mode, setMode] = useState('artworks')

  const SetMode = async(sort) => {
    setMode(sort);
  }


  return(
    <ContentFormatXC 
      name = 'Vault'
      home = {`/${form}/home`}
      link = {`/`}
      head = 'medium'
      form = 'medium'
      avtr = { <> </> }
      data = {
        <>
          
          <WebbDividerMedium />
          <StoreListModule />
          <WebbDividerMedium />

          <NavsVault sort={SetMode}/>
          <WebbDividerMedium />

          <div className={mode==='artworks' ? '' : 'd-none'}>
            <UsersArtworksModule />
          </div>

          <div className={mode==='videos' ? '' : 'd-none'}>
            <UsersVideosModule />
          </div>
        
          <div className={mode==='tokens' ? '' : 'd-none'}>
            <TokensListModule />
          </div>
          

          <WebbDividerMedium />



          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
          <WebbDividerMedium />
        </>
      } 
    />
  )
}